import uuid4 from 'uuid4'
import './TextInput.scss'
import { useState } from 'react'
import { isEmpty } from '../../Utils/Validations'

interface TextInputProps {
  value?: string
  onChange?: (newValue: string) => void
  label?: string
  helperText?: string
  placeholder?: string
  isValid?: boolean
  isReadOnly?: boolean
  suggestions?: string[]
  multiLine?: boolean
}

export function TextInput({
  value,
  onChange,
  label,
  helperText,
  placeholder,
  isValid,
  isReadOnly,
  suggestions,
  multiLine,
}: TextInputProps) {
  const [uniqueId] = useState(uuid4())
  const dataListId =
    !(multiLine ?? false) && suggestions != null && suggestions.length > 0
      ? `${uniqueId}-list`
      : undefined

  return (
    <div
      className={`text-input ${isValid === false ? 'invalid' : ''} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}
      {multiLine === true ? (
        <textarea
          className="input-element"
          value={value}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value)
            }
          }}
          placeholder={placeholder}
          readOnly={isReadOnly}
          rows={3}
        />
      ) : (
        <input
          type={dataListId != null ? 'search' : 'text'}
          className="input-element"
          value={value}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value)
            }
          }}
          placeholder={placeholder}
          readOnly={isReadOnly}
          list={dataListId}
        />
      )}
      {!isEmpty(helperText) ? (
        <div className="input-helper-text">{helperText}</div>
      ) : null}
      {!isEmpty(dataListId) ? (
        <datalist id={dataListId}>
          {suggestions?.map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>
      ) : null}
    </div>
  )
}
